<template>
  <v-tooltip bottom color="transparent">
    <template #activator="{ on }">
      <v-icon
        v-html="statusIcon"
        :color="statusColor"
        small
        v-on="on"
        @click="showLog"
      />
    </template>
    <v-alert
      border="left"
      colored-border
      :color="statusColor"
      style="box-shadow: 1px 1px 10px gray;"
    >
      <div style="display: grid; grid-template-columns: 0.1fr 3fr;">

        <v-icon v-html="statusIcon" :color="statusColor" />
        <h3 v-text="statusText" :class="statusColorClass"/>

        <div /> <!-- The empty <div/> is just to fill a collum space at Grid Layout  -->
        <p v-text="date" :class="statusColorClass" />

        <div />
        <p v-text="executionTime" :class="statusColorClass" />

        <div />
        <p v-text="identifier" :class="statusColorClass" />
      </div>
    </v-alert>
  </v-tooltip>
</template>
<script>
import Utils from '../../../utils'

export default {
  name: 'ExecutionPreview',

  props: { execution: Object, processType: String, integrationID: String },

  computed: {
    date () { return `${this.$t('monitoring.date')}: ${Utils.dateFormat(this.execution.date)}` },
    executionTime () {
      return `${this.$t('monitoring.execution_time')}: ${Utils.convertMSToTimeStamp(this.execution.executionTime)}`
    },
    identifier () { return `${this.$t('keywords.id')}: ${this.execution.monitoringID}` },
    statusIcon () { return Utils.getStatusIcon(this.execution.status) },
    statusColor () { return Utils.getStatusColor(this.execution.status) },
    statusText () { return this.$t('monitoring.status_values.' + this.execution.status) },
    statusColorClass () { return `${this.statusColor}--text` }
  },

  methods: {
    showLog () {
      const { processType, integrationID, execution: { date, monitoringID } } = this
      const query = { processType, integrationID, date, monitoringID }

      const someFieldInvalid = Object.values(query).some(v => !v)
      if (someFieldInvalid) return

      this.$router.push({ path: 'show-log', query })
    }
  }

}
</script>
<style scoped>
p {
  margin: 0 !important;
}
.v-tooltip__content.menuable__content__active {
  opacity: 1!important;
}
</style>
